import { useState, useEffect } from "react";
import api from "../lib/api";
import { MOODS, moodMeta } from "./Mood";

const LEVEL = { gestresst: 0, neutraal: 1, ontspannen: 2 };
const fmt = (s) => new Date(s).toLocaleDateString("nl-NL", { day: "numeric", month: "short" });

export const MoodHistory = ({ employeeId }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get(`/employees/${employeeId}/mood-history`).then(({ data }) => setItems(data), () => setItems([]));
  }, [employeeId]);

  if (!items) return <p className="text-xs text-zinc-400">Verloop laden…</p>;
  if (!items.length) return <p className="text-xs text-zinc-400" data-testid="mood-history-empty">Nog geen eerdere keuzes.</p>;
  const last = items.slice(-24);
  const counts = MOODS.map((m) => [m, items.filter((i) => i.mood === m.key).length]);

  return (
    <div className="space-y-3" data-testid="mood-history">
      <div className="relative h-20 border-l border-b border-zinc-300 ml-16">
        {MOODS.map((m) => (
          <span key={m.key} className="absolute -left-16 text-[10px] font-mono text-zinc-500 w-14 text-right" style={{ bottom: `${LEVEL[m.key] * 50}%`, transform: "translateY(50%)" }}>{m.label}</span>
        ))}
        <svg className="absolute inset-0 w-full h-full overflow-visible" viewBox="0 0 100 100" preserveAspectRatio="none">
          <polyline fill="none" stroke="#a1a1aa" strokeWidth="1" vectorEffect="non-scaling-stroke"
            points={last.map((i, k) => `${last.length === 1 ? 50 : (k / (last.length - 1)) * 100},${100 - LEVEL[i.mood] * 50}`).join(" ")} />
        </svg>
        {last.map((i, k) => (
          <span key={k} title={`${moodMeta(i.mood).label} · ${new Date(i.updated_at).toLocaleString("nl-NL")}`}
            className={`absolute h-2.5 w-2.5 rounded-full ring-2 ring-white ${moodMeta(i.mood).dot}`} data-testid={`mood-history-point-${k}`}
            style={{ left: `${last.length === 1 ? 50 : (k / (last.length - 1)) * 100}%`, bottom: `${LEVEL[i.mood] * 50}%`, transform: "translate(-50%, 50%)" }} />
        ))}
      </div>
      <div className="flex justify-between text-[10px] font-mono text-zinc-400 ml-16">
        <span>{fmt(last[0].updated_at)}</span><span>{fmt(last[last.length - 1].updated_at)}</span>
      </div>
      <div className="flex gap-4 text-xs text-zinc-600" data-testid="mood-history-counts">
        {counts.map(([m, n]) => <span key={m.key} className="flex items-center gap-1"><span className={`h-2 w-2 rounded-full ${m.dot}`} />{n}× {m.label.toLowerCase()}</span>)}
      </div>
      {items.length > last.length && <p className="text-[10px] text-zinc-400">Grafiek toont de laatste {last.length} van {items.length} keuzes.</p>}
    </div>
  );
};
